export enum Role {
    User = "User",
    Vip = "Vip",
    Admin = "Admin",
}
